var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18 4.051h-1.333c.034.171.054.628.054.809 0 1.454-1.514 2.637-2.948 2.637h-3.12c-1.434 0-2.948-1.183-2.948-2.637 0-.18.02-.638.054-.809H6a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5.051a1 1 0 0 0-1-1zm-1.987 6.956V12H7.992v-.993h8.021zm0 3V15H7.992v-.993h8.021zm0 3V18H7.992v-.993h8.021zM14 3a1.8 1.8 0 0 1 1.8 1.795A1.8 1.8 0 0 1 14 6.589h-3.6a1.8 1.8 0 0 1-1.8-1.794A1.8 1.8 0 0 1 10.4 3H14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.c66ad5831e9dc5a7969c7958fb92895a.svg";
export { ForwardRef as ReactComponent };